import { render, staticRenderFns } from "./Asignacionsedes.vue?vue&type=template&id=360f4b4d"
import script from "./Asignacionsedes.vue?vue&type=script&lang=js"
export * from "./Asignacionsedes.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports